let initialState = {
    fn: null,
    familyData: {},
    membersData: [],
    currentPage: 'familyInformation',
    currentMember: null,
    members: {},
    currentFrame: '',
    isExporting: false
};

const store = new Vuex.Store({

    state: initialState,

    mutations: {

        resetStore(state) {
            for (let f in state) {
                Vue.set(state, f, initialState[f]);
            }
        },

        SAVE_FAMILY(state, payload) {
            state.fn = payload;
        },

        SAVE_FAMILY_DATA(state, payload) {
            state.familyData = payload;
            if (state.familyData.familydetails) {
                state.familyData.familydetails = JSON.parse(state.familyData.familydetails);
            }
        },

        SAVE_MEMBERS_DATA(state, payload) {
            state.membersData = payload;
        },

        GO_TO_MEMBER(state, payload) {
            state.currentMember = payload;
            state.currentPage = 'memberInfo';
        },

        GO_TO_FAMILY(state) {
            state.currentPage = 'familyInformation';
        },

        GO_TO_FRAME(state, payload) {
            state.currentFrame = payload;
            state.currentPage = 'frame';
        },

        START_EXPORT(state) {
            state.isExporting = true;
        },

        END_EXPORT(state) {
            state.isExporting = false;
        }

    },

    actions: {

        GET_FAMILY_INFORMATION({
            commit,
            dispatch,
            state
        }, payload) {
            return new Promise((resolve, reject) => {
                axios.get('?page=getData&action=familyInformation', {
                    params: {
                        fn: payload
                    }
                })
                    .then(res => {

                        if (res.data.familyData == null || res.data.membersData == null) {
                            reject({
                                error: true,
                                msg: 'Sorry, no data is available for this family number'
                            });
                        } else {
                            commit('SAVE_FAMILY_DATA', res.data.familyData);
                            commit('SAVE_MEMBERS_DATA', res.data.membersData);
                        }

                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },


        GET_FAMILY_NUMBER({
            commit
        }, payload) {

            return new Promise((resolve, reject) => {
                axios.get('?page=getData&action=familyNumber', {
                    params: {
                        pn: payload[0],
                        kd: payload[1]
                    }
                })
                    .then(res => {
                        commit('SAVE_FAMILY', res.data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },

        GET_MEMBER_FULL_DATA({
            commit,
            dispatch,
            state
        }, {
            pn,
            kd
        }) {
            return new Promise((resolve, reject) => {
                axios.get('?page=getData&action=memberFullData', {
                    params: {
                        pn,
                        kd
                    }
                })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        },

        GET_EXPORT_DATA({
            commit,
            dispatch,
            state
        }, {
            members,
            fn
        }) {
            return new Promise((resolve, reject) => {
                axios.get('?page=getData&action=getMembersData', {
                    params: {
                        members,
                        fn
                    }
                })
                    .then(res => {
                        resolve(res)
                    })
                    .catch(err => {
                        reject(err);
                    });
            });
        }

    },

    getters: {

        fn: (state) => {
            return state.fn;
        },

        familyData: (state) => {
            return state.familyData;
        },

        membersData: (state) => {
            return state.membersData;
        },

        currentPage: (state) => {
            return state.currentPage;
        },

        currentMember: (state) => {
            return state.currentMember;
        },

        currentFrame: (state) => {
            return state.currentFrame;
        },

        isExporting: (state) => {
            return state.isExporting;
        }
    }
});
